import { render, staticRenderFns } from "./kro_derecha.vue?vue&type=template&id=2ccb9454&"
import script from "./kro_derecha.vue?vue&type=script&lang=js&"
export * from "./kro_derecha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports